import testEnv from './env.test';

export default testEnv;